import { useSuspenseQuery } from "@tanstack/react-query";
import { dashboardTrendingBrandsApi } from "@/features/dashboard/features/trending-brand-section/api";
import { TrendingBrandsQuery } from "@/features/dashboard/features/trending-brand-section/types";

export const useGetTrendingBrandList = (params: TrendingBrandsQuery) => {
  const { data: trendingBrandList } = useSuspenseQuery({
    queryKey: ["dashboard", "trendingBrandList", params],
    queryFn: () => dashboardTrendingBrandsApi.getTrendingBrands(params),
    select: (data) => data.data.slice(0, 100),
  });

  return { trendingBrandList };
};
